import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { JobBankService } from "../../services/jobBank.service";
import "./jobBank.scss";
import { Col, Form, Input, Row, Button, Select } from "antd";
import bannerBolsaTrabajo from "../../assets/imgs/banner-bolsatrabajo.png";
import { FaSearch } from "react-icons/fa";
import { AsideCategoriesJobs } from "./asideCategoriesJobs";
import {useValidTokenFromStorage} from "../../hooks/authHook";
import bannerJobBankGuest from "../../assets/imgs/banner_jobank.png";

export function JobBankHeader({ title, setFilters, filters, searchPage, handleCleanFilters }) {
    const roleName = useSelector((state) => state.userSettings.roleName);
    const [totalCount, setTotalCount] = useState(0);
    const validateToken = useValidTokenFromStorage();
    const [form] = Form.useForm();

    useEffect(() => {
    if (validateToken){GetJobsToApprove();}
    }, [])

  const GetJobsToApprove = () => {
    JobBankService.GetJobsToApprove(1, 8).then((result) => {
      if (!result) return;
      setTotalCount(result.totalCount);
    });
  };

  return (
    <Row gutter={[32,0]}>
      <Col xs={24}>
        <h2>{title}</h2>
      </Col>
      {
        (validateToken) && (
              <Col xl={12} lg={14} md={12} sm={24} xs={24}>
                <Row>
                  <Col xs={24}>
                    <AsideCategoriesJobs setFilters={setFilters} onSearchPage={searchPage} filters={filters} />
                  </Col>
                  <Col md={{ span: 0 }} sm={{ span: 24 }} xs={24}>
                    <article className="job-bank-header">
                      <div className="job-bank-header-thumb">
                        <img
                            className="drawer__bg__img"
                            src={bannerBolsaTrabajo}
                            alt="Ser parte de la comunidad PrideMx te da estos beneficios"
                        />
                      </div>
                    </article>
                  </Col>
                  <Col xs={24}>
                    <article className="job-bank-header">
                      <div className="job-bank-header-info mt-4">
                        <h4 className="mt-4">
                          Te ayudamos a encontrar el empleo ideal para ti de forma
                          rápida
                        </h4>
                          <Form
                              layout="vertical"
                              className="form-light"
                              form={form}
                              onValuesChange={(changedValues, allValues) => {
                                  setFilters({
                                      ...filters,
                                      locationFilter: allValues.location,
                                      occupationFilter: allValues.position
                                  });
                              }}
                          >
                              <Row gutter={16}>
                                  <Col lg={12} md={24} sm={24} xs={24}>
                                      <Form.Item name="location" label="Ubicación">
                                          <Input
                                              prefix={<i className="icon-location"></i>}
                                              size="large"
                                              placeholder="Ubicación"
                                          />
                                      </Form.Item>
                                  </Col>
                                  <Col lg={12} md={24} sm={24} xs={24}>
                                      <Form.Item name="position" label="Puesto">
                                          <Input
                                              size="large"
                                              prefix={<i className="icon-jobs"></i>}
                                              placeholder="Puesto, profesión, cargo, etc."
                                          />
                                      </Form.Item>
                                  </Col>
                                  <Col xl={12} lg={24} md={24} sm={24} xs={24}>
                                      <Form.Item name="sortBy" label="Ordenar por" className="job__select">
                                          <Select
                                              size="large"
                                              onChange={(value) => searchPage(1,12, value)}
                                          >
                                              <Select.Option value="Fecha">Fecha</Select.Option>
                                              <Select.Option value="Salario">Salario</Select.Option>
                                          </Select>
                                      </Form.Item>
                                  </Col>
                                  <Col xl={12} lg={24} md={24} sm={24} xs={24}>
                                      <div className={"form-light__footer"}>
                                          <Button
                                              htmlType="button"
                                              type="default"
                                              onClick={() => {
                                                  handleCleanFilters();   // Tu lógica para limpiar filtros
                                                  form.resetFields();     // Esto ahora sí limpia los campos visuales
                                              }}
                                              block={true}
                                          >
                                              Limpiar filtros
                                          </Button>
                                          <Button
                                              htmlType="button"
                                              type="primary"
                                              className="ant-btn-primary-green"
                                              onClick={() => searchPage()}
                                              block={true}
                                              icon={<FaSearch />}
                                          >
                                              Buscar
                                          </Button>
                                      </div>
                                  </Col>
                              </Row>
                          </Form>
                      </div>
                    </article>
                  </Col>
                </Row>
              </Col>
          )
      }
      <Col
          xl={(validateToken) ? 12 : 24}
          lg={(validateToken) ? 10 : 24}
          md={(validateToken) ? 12 : 24}
          sm={{
            span: (validateToken) ? 0 : 24
          }}
          xs={{ span: (validateToken) ? 0 : 24 }}
      >
        <div className="container-job-bank-header">
          <article className="job-bank-header">
            <div className="job-bank-header-thumb">
                {
                    (validateToken) ?
                        <img
                            className="drawer__bg__img"
                            src={bannerBolsaTrabajo}
                            alt="Ser parte de la comunidad PrideMx te da estos beneficios"
                        />
                        :
                        <img
                            className="drawer__bg__img"
                            src={bannerJobBankGuest}
                            alt="Ser parte de la comunidad PrideMx te da estos beneficios"
                        />
                }
            </div>
          </article>
          <div className="job-bank-btns">
            {roleName === "Recursos Humanos" && (
              <Link className="btn-gradient-green dark" to="/list-new-jobs">
                <span className="font-weight-bold">
                  {totalCount !== 0 ? (
                    <span style={{ marginRight: ".25rem" }}>{totalCount}</span>
                  ) : (
                    <span style={{ marginRight: ".25rem" }}>0</span>
                  )}
                  Autorizar vacantes
                </span>
                <span className="min">Administrador</span>
              </Link>
            )}
            {(validateToken) &&(<>
            <Link className="btn-gradient-green dark" to="/jobs-published">
              <span>Mis empleos</span>
              <span className="min">Empresas</span>
            </Link>
            <Link className="btn-gradient-green " to="/register-job">
              Publicar empleo
            </Link></>)
            }
          </div>
        </div>
      </Col>
    </Row>
  );
}
